import { DatasetID, FilterConfig } from '../../../models/filter.model';
import { FilterBase } from './FilterBase';
import { DATASET_INITIAL_ID } from '../../../constants';
import usePageFilters from 'common/hooks/usePageFilters';

export function FilterBuilder({ datasetId = DATASET_INITIAL_ID }: Readonly<Partial<DatasetID>>) {
  const { pageFilters, customFilters } = usePageFilters({ datasetId });

  return (
    <div className="filter-builder">
      <div className="filter-builder-main-filter">
        {pageFilters.length > 0 &&
          pageFilters.map((filter: FilterConfig) => {
            return <FilterBase {...filter} key={filter.property} datasetId={datasetId} />;
          })}
      </div>
      {customFilters?.length > 0 && (
        <div className="filter-builder-custom-filter">
          <span>Custom Filters</span>
          {customFilters?.map((filter: FilterConfig) => {
            return <FilterBase {...filter} key={filter.property} datasetId={datasetId} />;
          })}
        </div>
      )}
    </div>
  );
}
